import ManageSkillsController from "./ManageSkillsController";
import HeuristicsEditorComponent from "./heuristics/heuristicsEditorComponent";
import PedagogicalEditorComponent from "./pedagogical/pedagogicalEditorComponent";
import GdprExplanationsComponent from "./gdprExplanations/gdprExplanationsComponent";
import HeuristicsService from "./services/heuristicsService";
import ManageSkillsService from "./services/manageSkillsService";
import PedagogicalService from "./services/pedagogicalService";
import CurriculumService from "../evaluation/services/curriculumService";
import SubjectAreaService from "../evaluation/services/subjectAreaService";
import LearningAreaService from "../evaluation/services/learningAreaService";
import GradeService from "../evaluation/services/gradeService";
import CommonDataService from "../../services/commonDataService";
import UserService from "../../pages/user/services/userService";
import EvaluationService from "../evaluation/services/evaluationService";

import "./manageSkills.scss";

const ManageSkills = {
    template: require("./manageSkillsView.html"),
    controller: ManageSkillsController,
    bindings: {
        areaid: "=",
        curraspectname: "=",
    },
};

export default angular
    .module("app.manageSkills", ["ui.router"])
    .component("manageskills", ManageSkills)
    .component("heuristicsEditor", HeuristicsEditorComponent)
    .component("pedagogicalEditor", PedagogicalEditorComponent)
    .component("gdprEditor", GdprExplanationsComponent)
    .service("heuristicsService", HeuristicsService)
    .service("manageSkillsService", ManageSkillsService)
    .service("pedagogicalService", PedagogicalService)
    .service("curriculumService", CurriculumService)
    .service("subjectAreaService", SubjectAreaService)
    .service("learningAreaService", LearningAreaService)
    .service("gradeService", GradeService)
    .service("UserService", UserService)
    .service("EvaluationService", EvaluationService)
    .service("commonDataService", CommonDataService).name;



// WEBPACK FOOTER //
// ./src/app/pages/manageSkills/ManageSkillsComponent.js